var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26013 18.1275H8.56421V5.87249H4.26013C3.5625 5.87249 3 6.4425 3 7.13999V9.28503C3 9.89252 3.42755 10.4175 4.02759 10.5225C4.73254 10.6575 5.25 11.28 5.25 12C5.25 12.72 4.73254 13.3425 4.02759 13.4775C3.42755 13.5825 3 14.1075 3 14.715V16.86C3 17.5575 3.5625 18.1275 4.26013 18.1275ZM19.7325 5.87249H10.0642V18.1275H19.7325C20.43 18.1275 21 17.5575 21 16.86V14.715C21 14.1075 20.5649 13.5825 19.9651 13.4775C19.2601 13.3425 18.75 12.72 18.75 12C18.75 11.28 19.2601 10.6575 19.9726 10.5225C20.5649 10.4175 21 9.89252 21 9.28503V7.13999C21 6.4425 20.43 5.87249 19.7325 5.87249Z",
    fill: "#E8E13F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.48192a42.svg";
export { ForwardRef as ReactComponent };